import { createApi, retry } from "@reduxjs/toolkit/query/react";
import { createFlatBufferBaseQuery } from "../../flatbuffers/api/flatBufferBaseQuery";

const maxRetries = 2;

const baseQuery = retry(
  createFlatBufferBaseQuery(process.env.REACT_APP_LIFT_NET_CLOUD_API_ONLINE ?? ""),
  { maxRetries },
);

export const gitTokenAPI = createApi({
  reducerPath: "gitTokenAPI",
  baseQuery,
  keepUnusedDataFor: 0,
  tagTypes: ["tagGitToken"],
  refetchOnMountOrArgChange: true,
  endpoints: (builder) => ({
    //* *********************************************************** */
    //* GET GITHUB TOKEN STATUS */
    getGitToken: builder.query({
      query: (body: any) => ({
        url: "/github-token/",
        headers: { authorization: body.token },
      }),
      providesTags: ["tagGitToken"],
    }),
    //* *********************************************************** */
    //* SAVE OR UPDATE GITHUB TOKEN */
    putGitToken: builder.mutation({
      query: (body: any) => ({
        url: "/github-token/",
        method: "PUT",
        body: body.body,
        headers: { authorization: body.token },
      }),
      invalidatesTags: ["tagGitToken"],
    }),
    //* *********************************************************** */
    //* DELETE GITHUB TOKEN */
    deleteGitToken: builder.mutation({
      query: (body: any) => ({
        url: "/github-token/",
        method: "DELETE",
        headers: { authorization: body.token },
      }),
      invalidatesTags: ["tagGitToken"],
    }),
    //* *********************************************************** */
  }),
});

export const { useLazyGetGitTokenQuery, usePutGitTokenMutation, useDeleteGitTokenMutation } =
  gitTokenAPI;
